import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { To } from "react-router";

import { VisitTravelGroupsOverviewTravelGroupFragment } from "./fragments.generated";
import { TravelGroupCard, TravelGroupCardProps } from "./TravelGroupCard";

type VisitTravelGroupsOverviewProps = {
    travelGroups: VisitTravelGroupsOverviewTravelGroupFragment[];
    onTravelGroupCancelClick: TravelGroupCardProps["onTravelGroupCancelClick"];
    onShiftInTravelGroupCancelClick: TravelGroupCardProps["onShiftInTravelGroupCancelClick"];
    travelGroupOpenHref: (travelGroupId: string) => To;
    isCancelingShiftId: string | undefined;
    isCancelingGroupId: string | undefined;
};

export function VisitTravelGroupsOverview({
    travelGroups,
    onTravelGroupCancelClick,
    onShiftInTravelGroupCancelClick,
    travelGroupOpenHref,
    isCancelingShiftId,
    isCancelingGroupId,
}: VisitTravelGroupsOverviewProps) {
    const { t } = useTranslation("plannerV2");
    return (
        <Stack
            component="ul"
            margin={0}
            padding={2}
            sx={theme => ({
                backgroundColor: theme.palette.background.default,
            })}
            rowGap={2}
        >
            {travelGroups.length === 0 && <Typography variant="caption">{t("visitDetail.addFieldworkerInstruction")}</Typography>}
            {travelGroups.map(travelGroup => (
                <TravelGroupCard
                    key={travelGroup.id}
                    travelGroup={travelGroup}
                    onTravelGroupCancelClick={onTravelGroupCancelClick}
                    onShiftInTravelGroupCancelClick={onShiftInTravelGroupCancelClick}
                    travelGroupOpenHref={travelGroupOpenHref}
                    isCancelingShiftId={isCancelingShiftId}
                    isCancelingGroupId={isCancelingGroupId}
                />
            ))}
        </Stack>
    );
}
